import * as React from "react";

export const IconNavigationPlus = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 3.33301C10.4602 3.33301 10.833 3.70675 10.833 4.16699V9.16699L15.833 9.16699C16.2932 9.16699 16.667 9.53976 16.667 10C16.667 10.4602 16.2932 10.833 15.833 10.833L10.833 10.833L10.833 15.833C10.833 16.2932 10.4602 16.667 10 16.667C9.53976 16.667 9.16699 16.2932 9.16699 15.833L9.16699 10.833H4.16699C3.70675 10.833 3.33301 10.4602 3.33301 10C3.33301 9.53976 3.70675 9.16699 4.16699 9.16699H9.16699V4.16699C9.16699 3.70675 9.53976 3.33301 10 3.33301Z"
      fill="currentColor"
    />
  </svg>
);
